import { useActiveOrg } from '~/hooks/org'

export const useRequiredActiveOrg = () => {
  const isDev = process.env.APP_ENV !== 'production'
  const { org } = useActiveOrg()
  if (!org)
    throw new Error(
      'Active org required.' + isDev
        ? " Don't use this hook in non-authed routes."
        : '',
    )
  return org
}
